  export const parsePrompt = (input: string): string => {
    try {
      const trimmed = input.trim();
      const parsed = JSON.parse(trimmed);
      return parsed.input || "";
    } catch (error) {
      console.error("Failed to parse JSON:", error);
      return input; // Return original if parsing fails
    }
  };